import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ProjectTemplateDefinition } from './models/project-template-definition.model';

const BASE_URL = `${environment.apiConfig.url}/project-templates`;

@Injectable()
export class ProjectTemplateDefinitionService {
  constructor(private http: HttpClient) {}

  loadTemplateDefinition(templateId: number) {
    return this.http.get<ProjectTemplateDefinition>(`${BASE_URL}/${templateId}/form-data`);
  }
}
